export type TravelFileLogsTypes =
    | 'Start CPF'
    | 'Pay by credit card'
    | 'Other'
    | 'Queue'
    | 'Status Change'
    | 'Ticketing'
    | 'Dispatch'
    | 'Cashier'
    | 'Finish CPF'
    | 'Manual PNR synchronization'
    | 'Transaction Fee'
    | 'Automatic PNR synchronization'
    | 'Cancel Res'
    | 'Delete'
    | 'Split'
    | 'Benefit'
    | 'External system'
    | 'Update Balance'
    | 'Personal Details Change'
    | '';
export type TravelFileLogsKeys =
    | 'START_CPF'
    | 'PAY_BY_CREDIT_CARD'
    | 'OTHER'
    | 'QUEUE'
    | 'STATUS_CHANGE'
    | 'TICKETING'
    | 'DISPATCH'
    | 'CASHIER'
    | 'FINISH_CPF'
    | 'MANUAL_PNR_SYNCHRONIZATION'
    | 'TRANSACTION_FEE'
    | 'AUTOMATIC_PNR_SYNCHRONIZATION'
    | 'CANCEL_RES'
    | 'DELETE'
    | 'SPLIT'
    | 'BENEFIT'
    | 'EXTERNAL_SYSTEM'
    | 'UPDATE_BALANCE'
    | 'PERSONAL_DETAILS_CHANGE';
export const travelFileLogsTypesEnum: {
    [key in TravelFileLogsKeys]: TravelFileLogsTypes;
} = {
    START_CPF: 'Start CPF',
    PAY_BY_CREDIT_CARD: 'Pay by credit card',
    OTHER: 'Other',
    QUEUE: 'Queue',
    STATUS_CHANGE: 'Status Change',
    TICKETING: 'Ticketing',
    DISPATCH: 'Dispatch',
    CASHIER: 'Cashier',
    FINISH_CPF: 'Finish CPF',
    MANUAL_PNR_SYNCHRONIZATION: 'Manual PNR synchronization',
    TRANSACTION_FEE: 'Transaction Fee',
    AUTOMATIC_PNR_SYNCHRONIZATION: 'Automatic PNR synchronization',
    CANCEL_RES: 'Cancel Res',
    DELETE: 'Delete',
    SPLIT: 'Split',
    BENEFIT: 'Benefit',
    EXTERNAL_SYSTEM: 'External system',
    UPDATE_BALANCE: 'Update Balance',
    PERSONAL_DETAILS_CHANGE: 'Personal Details Change'
};
export const travelFileLogsValues = Object.values(travelFileLogsTypesEnum) as TravelFileLogsTypes[];
